export default __webpack_public_path__ + "static/media/p7.2f090bc7.jpg";